import React from 'react'

import { string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'

function TermsNotice({ locale = 'en' }) {
  const t = key => i18n.t(`auth_modal.terms.${key}`, { ns: 'rails', lng: locale })

  // Segments carry their own spacing and the suffix holds trailing text so
  // verb-final languages (de, ja) can close the sentence after the links.
  return (
    <p className="auth-modal__terms cgt-caption">
      {t('prefix')}
      <a
        className="cgt-link-primary-accented"
        href="/pages/terms-and-conditions"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('terms_link')}
      </a>
      {t('middle')}
      <a
        className="cgt-link-primary-accented"
        href="/pages/privacy-policy"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('privacy_link')}
      </a>
      {t('suffix')}
    </p>
  )
}

TermsNotice.propTypes = {
  locale: string,
}

export default TermsNotice
